/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Achievementsdlclabel2Inputs */

const id_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ms_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const da_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const de_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const en_us2_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const es_es2_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const es_mx2_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const fil_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const fr_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const it_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const hu_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const nl_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const no_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const pl_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const pt_br2_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const pt_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ro_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const fi_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const sv_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const vi_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const tr_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const cs_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const bg_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ru_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const uk_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ar_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const hi_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const th_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ja_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const zh_cn2_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const zh_hant1_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ko_sandboxes_achievementsdlclabel2 = /** @type {(inputs: Sandboxes_Achievementsdlclabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

/**
* | output |
* | --- |
* | "DLC" |
*
* @param {Sandboxes_Achievementsdlclabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_achievementsdlclabel2 = /** @type {((inputs?: Sandboxes_Achievementsdlclabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Achievementsdlclabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "ms") return ms_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "da") return da_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "de") return de_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "fil") return fil_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "fr") return fr_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "it") return it_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "hu") return hu_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "nl") return nl_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "no") return no_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "pl") return pl_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "pt") return pt_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "ro") return ro_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "fi") return fi_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "sv") return sv_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "vi") return vi_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "tr") return tr_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "cs") return cs_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "bg") return bg_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "ru") return ru_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "uk") return uk_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "ar") return ar_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "hi") return hi_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "th") return th_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "ja") return ja_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_achievementsdlclabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_achievementsdlclabel2(inputs)
	return ko_sandboxes_achievementsdlclabel2(inputs)
});
export { sandboxes_achievementsdlclabel2 as "sandboxes.achievementsDlcLabel" }